/**
 * @generated SignedSource<<bb9db46775bf856d861fdafd6ed03e7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeAdvisorInsight$data = {
  readonly isMet: boolean;
  readonly text: string;
  readonly " $fragmentType": "CreativeAdvisorInsight";
};
export type CreativeAdvisorInsight$key = {
  readonly " $data"?: CreativeAdvisorInsight$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeAdvisorInsight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeAdvisorInsight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMet",
      "storageKey": null
    }
  ],
  "type": "Insight",
  "abstractKey": null
};

(node as any).hash = "b2542adfbde54e7e75031540e3cce624";

export default node;
